import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from '../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view06ImageOptions } from './views/exterior_view06'

class X56Wheel extends Component {
    constructor(props) {
        super(props);
        this.handleWheelChange = this.handleWheelChange.bind(this);
        this.handleSeatChange = this.handleSeatChange.bind(this);
        this.handleBenchChange = this.handleBenchChange.bind(this);
    }
    
    handleWheelChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Wheel = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleSeatChange(event) {
        let configuration = this.props.configuration;
        configuration.WheelingSeats = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBenchChange(event) {
        let configuration = this.props.configuration;
        configuration.AftBench = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view06ImageOptions;

        let image = <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Wheels' /></h1>
                    <RadioGroup label={this.props.t("Options:")} options={this.props.wheelOptions} value={this.props.configuration.Wheel} onChange={this.handleWheelChange} />

                    <Toggle checked={this.props.configuration.WheelingSeats.value === 2} onChange={this.handleSeatChange}>
                        <Trans defaults='Detachable Helmsman seats' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.AftBench.value === 2} onChange={this.handleBenchChange}>
                        <Trans defaults='Center pushpit with space for liferaft' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56Wheel);


// WEBPACK FOOTER //
// ./src/X56/X56Wheel.js